module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ../~/react-hot-loader/index.js
// module id = 1024
// module chunks = 0